import { DEFAULT_SEARCH_PARAMS } from '@/constants/insights';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { ReadonlyURLSearchParams } from 'next/navigation';

export const addTagsToSearchParams = (
  tag: string,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const urlSearchParams = new URLSearchParams(searchParams.toString());
  const currentSelectedTagsFromSearchParams = urlSearchParams.get(DEFAULT_SEARCH_PARAMS.tags);
  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.page, '1');

  if (currentSelectedTagsFromSearchParams) {
    urlSearchParams.set(DEFAULT_SEARCH_PARAMS.tags, [...currentSelectedTagsFromSearchParams.split(','), tag].join(','));
  } else {
    urlSearchParams.set(DEFAULT_SEARCH_PARAMS.tags, tag);
  }

  router.replace(`${pathname}?${urlSearchParams.toString()}`, {
    scroll: false,
  });
};

export const addSingleTagsToSearchParams = (
  tag: string,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const urlSearchParams = new URLSearchParams(searchParams.toString());

  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.page, '1');
  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.tags, tag);

  router.replace(`${pathname}?${urlSearchParams.toString()}`, {
    scroll: false,
  });
};

export const addSingleCategoryToSearchParams = (
  category: string,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const urlSearchParams = new URLSearchParams(searchParams.toString());

  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.page, '1');
  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.category, category);

  router.replace(`${pathname}?${urlSearchParams.toString()}`, {
    scroll: false,
  });
};

export const removeTagsToSearchParams = (
  tag: string,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const urlSearchParams = new URLSearchParams(searchParams.toString());
  const currentSelectedTagsFromSearchParams = urlSearchParams.get(DEFAULT_SEARCH_PARAMS.tags);
  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.page, '1');

  if (currentSelectedTagsFromSearchParams?.split(',').length === 1) {
    urlSearchParams.delete(DEFAULT_SEARCH_PARAMS.tags);
    router.replace(`${pathname}?${urlSearchParams.toString()}`, {
      scroll: false,
    });

    return;
  }

  if (currentSelectedTagsFromSearchParams) {
    urlSearchParams.set(
      DEFAULT_SEARCH_PARAMS.tags,
      currentSelectedTagsFromSearchParams
        .split(',')
        .filter((item) => item !== tag)
        .join(','),
    );
  }

  router.replace(`${pathname}?${urlSearchParams.toString()}`, {
    scroll: false,
  });
};

export const clearSearchParams = (
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const urlSearchParams = new URLSearchParams(searchParams.toString());
  urlSearchParams.delete(DEFAULT_SEARCH_PARAMS.tags);
  urlSearchParams.delete(DEFAULT_SEARCH_PARAMS.category);
  urlSearchParams.set(DEFAULT_SEARCH_PARAMS.page, '1');

  router.replace(`${pathname}?${urlSearchParams.toString()}`, {
    scroll: false,
  });
};

export const setPageToSearchParams = (
  page: string | number,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const newSearchParams = new URLSearchParams(searchParams);
  newSearchParams.set(DEFAULT_SEARCH_PARAMS.page, page.toString());
  router.replace(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
};
